/**
 * Check cart item list medicine restrictions (delivery and substances)
 */
function _checkMedicineRestriction() {
  //Every time cart changes check all items and  restrictions
  //Set variables needed for the restrictions check and set info text empty string
  var adminRestrictionTextString = document
    .getElementById('medicine-restriction-texts')
    .getAttribute('data-medicine-restriction-text');
  var adminDeliveryRestrictionString = document
    .getElementById('medicine-restriction-texts')
    .getAttribute('data-medicine-restriction-delivery-text');
  var collectedRestrictionsValues = [];
  var cart = this;
  var restrictionsFound = false;
  var deliveryRestrictionFound = false;

  // Clear message and set container visible none if previous message found
  if (true || document.getElementById('medicine-max-amount-info').textContent != '') {
    document.getElementsByClassName('medicine-max-amount-info-container')[0].style.display = 'none';
    document.getElementById('collected-medicine-restrictions-text-list').innerHTML = '';
    document.getElementsByClassName('cart-info-container')[0].style.paddingTop = '0px';
    document.getElementsByClassName('cart-info-container')[0].style.paddingBottom = '0px';
    document.getElementById('medicine-max-amount-info').textContent = '';
  }

  //Clear message and set container visible none if previous message found
  if (true || document.getElementById('medicine-delivery-info').textContent != '') {
    document.getElementsByClassName('medicine-delivery-restriction-container')[0].style.display = 'none';
    document.getElementById('medicine-delivery-info').textContent = '';
  }

  //Loop through cart items for the restrictions
  var line = 0;
  document.querySelectorAll('.cart-item__data').forEach(function (item) {
    line++;

    //Collect product restrictions values
    var restrictionAmountString = item.dataset.cartitemMedicineRestrictionAmount;
    var restrictionMaxAllowedAmountString = item.dataset.cartitemMedicineRestrictionMaxAllowedAmount;
    var restrictionCodeString = item.dataset.cartitemMedicineRestrictionCode;
    var itemRestrictionTextString = item.dataset.cartitemMedicineRestrictionText;
    var restrictionProductName = item.dataset.cartitemMedicineRestrictionProductName;
    var restrictionVariantInfo = item.dataset.cartitemMedicineRestrictionVariantInfo;
    var deliveryRestriction = item.dataset.cartitemMedicineStatus;

    //Check only once
    if (!deliveryRestrictionFound) {
      if (deliveryRestriction == 'true') {
        deliveryRestrictionFound = true;
      }
    }

    //Only start collecting values if product has restrictions
    if (restrictionAmountString != '' && restrictionMaxAllowedAmountString != '' && restrictionCodeString != '') {
      var item_amount = parseInt(document.getElementById(`Quantity-${line}`).value);
      var restrictionMaxAllowedAmount = parseInt(restrictionMaxAllowedAmountString);
      var restrictionAmount = parseInt(restrictionAmountString);
      var collectedAmount = restrictionAmount * item_amount;
      var restrictionUpdated = false;

      //Loop through collected restrictions and make update if existing restriction item found
      collectedRestrictionsValues.map((restriction, i) => {
        if (restriction.restrictionCode == restrictionCodeString) {
          restrictionUpdated = true;
          restriction.collectedAmount += collectedAmount;
          restriction.restrictionVariantInfo.push(restrictionVariantInfo + ' ');

          if (restriction.collectedAmount > restrictionMaxAllowedAmount && !restriction.restrictionFound) {
            restriction.restrictionFound = true;
            restriction.restrictionText = itemRestrictionTextString;
            restriction.restrictionProductName = restrictionProductName;
          }
        }
      });

      if (collectedAmount > restrictionMaxAllowedAmount) {
        document.getElementById(`Att-${line}`).hidden = false;
      } else {
        document.getElementById(`Att-${line}`).hidden = true;
      }

      //No update -> insert new record
      if (!restrictionUpdated) {
        collectedRestrictionsValues.push({
          restrictionCode: restrictionCodeString,
          collectedAmount: collectedAmount,
          restrictionFound: collectedAmount > restrictionMaxAllowedAmount ? true : false,
          restrictionText: itemRestrictionTextString,
          restrictionProductName: restrictionProductName,
          restrictionVariantInfo: [restrictionVariantInfo + ' '],
        });
      }
    }
  });

  // Add second pass to mark all related items when restrictions are found
  collectedRestrictionsValues.forEach(function(restriction) {
    if (restriction.restrictionFound) {
      line = 0;
      document.querySelectorAll('.cart-item__data').forEach(function (item) {
        line++;
        var itemRestrictionCode = item.dataset.cartitemMedicineRestrictionCode;
        if (itemRestrictionCode === restriction.restrictionCode) {
          console.log('restriction found');
          console.log(restriction);
          const attElement = document.getElementById(`Att-${line}`);
          attElement.hidden = false;
          // Add tooltip attributes
          attElement.setAttribute('title', restriction.restrictionText);
          attElement.style.cursor = 'help';
          // Optional: Add aria-label for accessibility
          attElement.setAttribute('aria-label', restriction.restrictionText);
        }
      });
    }
  });

  // Also update the first pass to include tooltips for individual items
  line = 0;
  document.querySelectorAll('.cart-item__data').forEach(function (item) {
    line++;
    var restrictionText = item.dataset.cartitemMedicineRestrictionText;
    if (restrictionText) {
      const attElement = document.getElementById(`Att-${line}`);
      attElement.setAttribute('title', restrictionText);
      attElement.style.cursor = 'help';
      attElement.setAttribute('aria-label', restrictionText);
    }
  });

  //Check if restrictions found and show messages
  collectedRestrictionsValues.map((restriction, i) => {
    //console.log('restriction');
    //console.log(restriction);
    if (restriction.restrictionFound) {
      if (document.getElementById('medicine-max-amount-info').textContent == '') {
        document.getElementById('medicine-max-amount-info').textContent = adminRestrictionTextString;
        document.getElementsByClassName('medicine-max-amount-info-container')[0].style.display = 'block';
        document.getElementsByClassName('cart-info-container')[0].style.paddingTop = '40px';
        document.getElementsByClassName('cart-info-container')[0].style.paddingBottom = '40px';
      }
      document.getElementById('collected-medicine-restrictions-text-list').innerHTML +=
        '<li>' + restriction.restrictionText + '</li>';
    }
  });

  //show admin delivery text if delivery restrictions found
  if (deliveryRestrictionFound) {
    document.getElementById('medicine-delivery-info').textContent = adminDeliveryRestrictionString;
    document.getElementsByClassName('medicine-delivery-restriction-container')[0].style.display = 'block';
  }
}
